import ActivityReason from './ActivityReason'
import EquipmentClass from './EquipmentClass'
import EquipmentLineItemType from './EquipmentLineItemType'
import ExportFile from './ExportFile'
import RequestType from './RequestType'
export class EquipmentTemplateRule {
    ID?: number;
    NotificationType?: string;
    CodingA?: string;
    CodingB?: string;
    ShortDescription?: string;
    Description?: string;
    ActivityReasonID?: number;
    ActivityReason?: ActivityReason;
    EquipmentClassID?: number;
    EquipmentClass?: EquipmentClass;
    EquipmentLineItemTypeID?: number;
    EquipmentLineItemType?: EquipmentLineItemType;
    ExportFileID?: number;
    ExportFile?: ExportFile;
    RequestTypeID?: number;
    RequestType?: RequestType;
    SpecialEvent?: boolean;
    SerializedAsset?: boolean;
    Survey?: boolean;
}

export default EquipmentTemplateRule;